import { render, staticRenderFns } from "./render-rule-config.vue?vue&type=template&id=862a58aa"
import script from "./render-rule-config.vue?vue&type=script&lang=js"
export * from "./render-rule-config.vue?vue&type=script&lang=js"
import style0 from "./render-rule-config.vue?vue&type=style&index=0&id=862a58aa&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports